import styled from "styled-components";

export const TertiaryHeader = styled.h3`
  font-family: ${({ theme }) => theme.fonts.tertiaryHeader.family};
  font-size: ${({ theme }) => theme.fonts.tertiaryHeader.fontSize};
  line-height: ${({ theme }) => theme.fonts.tertiaryHeader.lineHeight};
  font-weight: ${({ theme }) => theme.fonts.tertiaryHeader.fontWeight};
  letter-spacing: ${({ theme }) => theme.fonts.tertiaryHeader.letterSpacing};
  max-width: ${({ theme }) => theme.copyMaxWidth};
  color: ${({ theme }) => theme.colors.typographyDefault};
`;
